import { useEffect, useState } from "react";
import type { IHaulierSelectItem } from "@/customTypings/haulier/Haulier";
import type { IVehicleSelectItem } from "@/customTypings/vehicle/Vehicle";
import { hauliersService } from "@/services/hauliers/hauliers.service";
import { vehiclesService } from "@/services/vehicles/vehicles.service";
import { logErrorForDev } from "@/utils";

export type WasteMovementCarrierLookups = {
    hauliers: IHaulierSelectItem[];
    vehicles: IVehicleSelectItem[];
};

const EMPTY: WasteMovementCarrierLookups = { hauliers: [], vehicles: [] };

/** Haulier (site-scoped) and vehicle (organisation-scoped) lists used only to pre-fill the movement's copied carrier values. */
export function useWasteMovementCarrierLookups(siteId: string, enabled: boolean) {
    const [lookups, setLookups] = useState<WasteMovementCarrierLookups>(EMPTY);

    useEffect(() => {
        if (!enabled || !siteId) {
            setLookups(EMPTY);
            return;
        }
        let cancelled = false;
        Promise.all([
            hauliersService.select(siteId).catch((e: unknown) => {
                logErrorForDev("wasteMovement.carrier.hauliers", e);
                return [] as IHaulierSelectItem[];
            }),
            vehiclesService.select().catch((e: unknown) => {
                logErrorForDev("wasteMovement.carrier.vehicles", e);
                return [] as IVehicleSelectItem[];
            }),
        ]).then(([hauliers, vehicles]) => {
            if (!cancelled) setLookups({ hauliers, vehicles });
        });
        return () => {
            cancelled = true;
        };
    }, [siteId, enabled]);

    return lookups;
}
